import CITY_DICT_FIXED from '@/dict/city.js'
import AREA_DICT_FIXED from '@/dict/area.js'

export default {
  namespaced: true,
  state: {
    // 系统字典树
    tree: {},
    // 系统字典健值对
    keyValue: {},

    // 城市字典: 字典数组
    cityList: CITY_DICT_FIXED.DICT_LIST,
    // 城市字典: 字典键值对
    cityKeyValue: CITY_DICT_FIXED.DICT_KEY_VALUE,

    // 省市区字典: 字典树
    areaTree: AREA_DICT_FIXED.DICT_TREE,
    // 省市区字典: 键值对
    areaKeyValue: AREA_DICT_FIXED.DICT_KEY_VALUE,

    cityData: []
  },
  mutations: {
    setTree(state, tree) {
      state.tree = tree || {}
    },
    setKeyValue(state, keyValue) {
      state.keyValue = keyValue || []
    },
    setCityData(state, cityData) {
      state.cityData = cityData
    }
  },
  actions: {
    async init({ dispatch }) {
      dispatch('setCityData')
    },
    setCityData({ commit }) {
      this._vm.$dynamicLoadScript({
        src: 'https://file.kinfriend.com/js/city.data.js',
        callback: err => {
          !err && commit('setCityData', window.CITY_DATA)
        },
        checkLoaded: () => window.CITY_DATA
      })
    }
  }
}
